module.exports = __webpack_public_path__ + "4936771b05d586d00056659a909dec23.png";